import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';

class HistoryController {
    constructor() {
        this.prevState = window.history.state;
        this.subscribers = {};

        this.init();
    }

    init() {
        window.addEventListener('popstate', this.onPopstate);
    }

    destroy() {
        window.removeEventListener('popstate', this.onPopstate);
    }

    onPopstate = (event) => {
        const prevId = get(this.prevState, 'id', null);
        const id = get(event, 'state.id', null);
        const prevInnerState = get(this.prevState, 'state', null);
        const newInnerState = get(event.state, 'state', null);

        // inform component to clean his state
        if (prevId !== id && this.subscribers[prevId]) {
            this.subscribers[prevId].cb(prevInnerState, newInnerState, true);
        }

        if (id && this.subscribers[id]) {
            this.subscribers[id].cb(prevInnerState, newInnerState, false);
        }

        this.prevState = event.state;
    }

    register(id, cb) {
        if (this.subscribers[id]) {
            console.log(`Found registered component with id: ${id}. Data will be overridden.`);
        }

        this.subscribers[id] = { cb };

        return () => {
            delete this.subscribers[id];
        };
    }

    getState() {
        return get(window.history.state, 'state', null);
    }

    pushState(id, title, url, state = {}) {
        if (!id) {
            console.log('You must provide component id');
            return;
        }

        const historyState = {
            id,
            state: cloneDeep(state)
        };

        if (!historyState.state.url) {
            historyState.state.url = url;
        }

        if (!historyState.state.originalTitle) {
            historyState.state.originalTitle = document.title;
        }

        if (title) {
            document.title = title;
        }

        window.history.pushState(historyState, title, url);
        this.prevState = window.history.state;
    }
}

export default new HistoryController();
